









































































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import SliderToggler from "_C/main/Step4/SliderToggler.vue";
import PersonNameBD from "_C/main/FormParts/PersonForm/PersonNameBD.vue";
import PersonDocument from "_C/main/FormParts/PersonForm/PersonDocument.vue";
import { DefaultCopy } from "_P/copyobj";
import { InsuranceCard, Person } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
@Component({
    components: { PersonDocument, PersonNameBD, SliderToggler },
})
export default class PersonDisplay extends Vue {
    @Prop() isInsurer: boolean;

    Rules = ValidationRules;

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    get person(): Person {
        return this.isInsurer ? this.card.insurer : this.card.owner;
    }
    set person(val) {
        if (this.isInsurer) {
            this.card.insurer = val;
            if (this.card.insurerIsOwner)
                this.card.owner = DefaultCopy(this.card.insurer);
        } else this.card.owner = val;
    }

    facePerson: Person = DefaultCopy(this.person) as Person;

    @Ref("form") form: { validate: Function };
    applyChanges() {
        let isValid = this.form.validate();
        if (!isValid) {
            this.cancelChanges();
            return;
        }

        if (this.isInsurer && this.card.insurerIsOwner) {
            this.card.owner = DefaultCopy(this.facePerson);
        }
        this.person = DefaultCopy(this.facePerson);
    }
    cancelChanges() {
        this.facePerson = DefaultCopy(this.person) as Person;
    }
    @Ref("st") st: SliderToggler;
    isEdit(): boolean {
        return this.st.isEdit;
    }
}
